import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Breadcrumb({ mType, appType, currentPage }) {
  const navigate = useNavigate();

  const goToMain = () => {
    navigate("/");
  };

  const goToMType = () => {
    navigate(`/${mType}`);
  };

  const getMTypeText = () => {
    if (mType === "alumni") {
      return "EdUHK Alumni";
    } else if (mType === "teacher") {
      return "School Teacher";
    } else if (mType === "individual") {
      return "Individual";
    } else if (mType === "organisation") {
      return "Organisation";
    } else if (mType === "school") {
      return "School";
    }
  };

  return (
    <nav className="flex mb-4" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        <li className="inline-flex items-center">
          <button
            onClick={goToMain}
            className="inline-flex items-center text-sm font-medium text-orange-600"
          >
            Online Application for Library External Membership
          </button>
        </li>
        {mType && (
          <li>
            <div className="flex items-center">
              <svg
                aria-hidden="true"
                className="w-6 h-6 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <button
                onClick={goToMType}
                className="inline-flex items-center text-sm font-medium text-orange-600 ml-2"
              >
                {getMTypeText()}
              </button>
            </div>
          </li>
        )}
        <li aria-current="page">
          <div className="flex items-center">
            <svg
              aria-hidden="true"
              className="w-6 h-6 text-gray-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span className="text-sm font-medium text-gray-500 ml-2">
              {currentPage
                ? currentPage
                : appType === "renew"
                ? "Card Renewal"
                : appType === "repl"
                ? "Card Replacement"
                : "New Application"}
            </span>
          </div>
        </li>
      </ol>
    </nav>
  );
}
